import { useEffect, Suspense, lazy, useState } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import { theme } from "styled-tools";
import { MetaProps, SEOMetaCommon } from "src/components/SEOMetaCommon";
import { tncPagesSEOData } from "src/config/seo_api";

function PrivacyPolicy(props: any) {

    const {
        app: { brandId }, theme
    } = props;
	const { config: { showAPISEOData } } = theme;
	const [seoObjects, setseoObjects] = useState({} as MetaProps);

    useEffect(() => {
        window.scrollTo(0, 0)
    },[]);

	//for SEO
	useEffect(() => {
		if (showAPISEOData) {
			const getSeoData = tncPagesSEOData();
			const pathName = "/about/privacy-policy";

			getSeoData.then(resp => {
				const { objects } = resp;
				const seoData = objects.find((obj: any) => {
					const { metadata = {} } = obj;
					if (metadata.pathname && metadata.pathname === pathName) {
						return obj;
					}

				}) || {};

				const { metadata = {} } = seoData;
				setseoObjects(metadata);

			}).catch(error => console.log(`[${pathName}]:Error in SEO API`))
		}
	}, []);

    const Contents = brandId && brandId === 32 ? lazy(() => import("src/components/fine_print/privacy32")) : 
	brandId && (brandId === 39) ? lazy(() => import("src/components/fine_print/privacy39")) : 
	(brandId === 40) ? lazy(() => import("src/components/fine_print/privacy40")) :
	(brandId === 46 || brandId === 47) ? lazy(() => import("src/components/fine_print/privacyfun88")) :
	lazy(() => import("src/components/fine_print/privacy31"))


	return (
		<>
			{showAPISEOData && (<SEOMetaCommon metaData={seoObjects} />)}

			<ContentWrapper>
				<Suspense fallback={<div>Loading ... </div>}>
					<Contents />
				</Suspense>
			</ContentWrapper>
		</>
	)
}

export default withTheme(withAppContext(PrivacyPolicy));

const ContentWrapper = styled.div`
	max-width: 800px;
	margin: 0 auto;
	font-size: 12px;
	padding: 5.5em 1.25em;
    text-transform: capitalize;

    h1{
		color: ${theme('palette.seoContenAccordionInnerAngerTagColor')};
    }

    p,
	h3,
	h4,
	h5,
	h6 {
		color:${theme('palette.nametext')};
		margin-top: 1.23em;
	}

	h1 {
		font-size: 18px;
	}

	h2 {
		font-size: 16px;
	}

	h3 {
		font-size: 14px;
	}

	ul ul,
	ol {
		margin: 1em 0;
	}

	li {
		color:${theme('palette.nametext')};		margin: 0.75em 0;
	}

	a {
		color: #EEBC15;
		text-decoration: underline;
	}

    span{
        font-weight: 700;
    }

	.brandColor {
		color: #0366fd;
		text-transform: lowercase;
		font-weight: bold;
	}
`;